document.addEventListener("DOMContentLoaded", () => {
  const field = document.querySelector(".cyprus-acs-point-field");
  const select = document.querySelector("#cyprus_acs_station");
  if (!field || !select || typeof cyprusAcsSettings === "undefined") return;

  const isPointRate = () => {
    const selected = document.querySelector('input[name^="shipping_method"]:checked');
    if (!selected || selected.value.indexOf("cyprus_acs:") !== 0) return false;
    const rateText = selected.closest("li")?.textContent || selected.parentElement?.textContent || "";
    return /point|smart locker/i.test(rateText);
  };

  const updateVisibility = () => {
    field.style.display = isPointRate() ? "" : "none";
    select.required = isPointRate();
  };

  const loadStations = async () => {
    if (select.options.length > 1) return;
    const body = new URLSearchParams({ action: "cyprus_acs_stations", nonce: cyprusAcsSettings.nonce });
    try {
      const response = await fetch(cyprusAcsSettings.ajaxUrl, { method: "POST", body });
      const result = await response.json();
      if (!result.success) throw new Error(result.data?.message || "ACS stations could not be loaded.");
      result.data.forEach((station) => {
        const option = document.createElement("option");
        option.value = `${station.id}:${station.branch}`;
        option.textContent = `${station.name}${station.address ? ` — ${station.address}` : ""}${station.city ? `, ${station.city}` : ""}`;
        select.appendChild(option);
      });
    } catch (error) {
      select.options[0].textContent = error.message;
    }
  };

  const refresh = () => {
    updateVisibility();
    if (isPointRate()) loadStations();
  };

  document.body.addEventListener("updated_checkout", refresh);
  if (window.jQuery) window.jQuery(document.body).on("updated_checkout", refresh);
  document.body.addEventListener("change", (event) => {
    if (event.target.matches('input[name^="shipping_method"]')) refresh();
  });
  refresh();
});
